import {
  REQUEST_COLLABORATOR_NETWORK,
  RESPONSE_COLLABORATOR_NETWORK,
  FAILURE_COLLABORATOR_NETWORK,
  REQUEST_EXPERT_COLLABORATORS,
  RESPONSE_EXPERT_COLLABORATORS,
  FAILURE_EXPERT_COLLABORATORS,
  COLLAB_CLUSTER_UPDATE,
  RESPONSE_MAIN_NETWORK_SEARCH_TERMS
} from "../../actions/types";

const initialState = {
  keyword: "",
  isFetching: false,
  error: false,
  isInitalScreen: true,
  cluster_no: 0,
  nodes: [],
  edges: {},
  relatedTerms: {
    close: [],
    distant: []
  },
  selectedId: "",
  isCollabsFetching: false,
  allCollabs: [],
  keywordCloud: [],
  locationCloud: [],
  statusCode: 0,
  terms: "",
  country: "",
  experts: [],
  freeKeyword: [],
  university: [],
  totalConnections: {},
  activeSortItem: { value: "citation_count", label: "Total Related Citation" },
  size: 100,
  year: "",
  networkType: undefined
};

const setFetching = (state, action) => {
  const {
    terms = "",
    country = "",
    year = "",
    experts = [],
    university = [],
    freeKeyword = [],
    size = 200,
    selectedNodes = [],
    networkType
  } = action.payload;

  let keyword = terms.split(",");
  keyword = keyword.join(", ");

  return {
    ...state,
    isFetching: true,
    keyword: action.payload.keyword,
    isInitalScreen: false,
    nodes: [],
    edges: {},
    relatedTerms: {
      close: [],
      distant: []
    },
    keywordCloud: [],
    locationCloud: [],
    totalConnections: {},
    keyword,
    selectedId: "",
    isCollabsFetching: false,
    allCollabs: [],
   
    statusCode: 0,
    country,
    selectedNodes,
    terms:terms,
    experts,
    freeKeyword,
    university,
    selectedNodes,
    size,
    year,
    networkType
  };
};

const setResponseTerms = (state, action) => {
  let relatedTerms = action.payload || {};
  let newRelatedTerms = {
    close: relatedTerms.close || [],
    distant: relatedTerms.distant || []
  };
  return {
    ...state,
    relatedTerms: newRelatedTerms
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    relatedTerms: {
      close: [],
      distant: []
    },
  };
};

const updateCluster = (state, action) => {
  let cluster_no = action.payload.results;

  return {
    ...state,
    cluster_no
  };
};

const setResults = (state, action) => {
  let nodes = action.payload.node_output || [];
  let edges = action.payload.edges_output || {};
  let keywordCloud = action.payload.keyword_cloud || [];
  let locationCloud = action.payload.location_cloud || [];
  let statusCode = action.payload.statusCode;
  let topCluster = keywordCloud.sort((a, b) => b.citation - a.citation)[0] || {};
  let cluster_no = topCluster['cluster_number']?topCluster['cluster_number']:0
  let totalConnections = action.payload.total_connections || {}
    return {
    ...state,
    isFetching: false,
    error: false,
    nodes,
    edges,
    keywordCloud,
    locationCloud,
    statusCode,
    cluster_no,
    totalConnections
  };
};

const setExpertCollabsRequest = (state, action) => {
  let selectedId = action.payload.id;
  return {
    ...state,
    selectedId,
    isCollabsFetching: true,
    allCollabs: []
  };
};

const setExpertCollabsResponse = (state, action) => {
  let allCollabs = action.payload.collabs || [];
  return {
    ...state,
    isCollabsFetching: false,
    allCollabs
  };
};

const setExpertCollabsFailure = (state, action) => {
  return {
    ...state,
    isCollabsFetching: false
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_COLLABORATOR_NETWORK:
      return setFetching(state, action);
      break;

    case RESPONSE_COLLABORATOR_NETWORK:
      return setResults(state, action);

    case FAILURE_COLLABORATOR_NETWORK:
      return setFailure(state, action);

    case REQUEST_EXPERT_COLLABORATORS:
      return setExpertCollabsRequest(state, action);

    case RESPONSE_EXPERT_COLLABORATORS:
      return setExpertCollabsResponse(state, action);

    case FAILURE_EXPERT_COLLABORATORS:
      return setExpertCollabsFailure(state, action);
    
    case RESPONSE_MAIN_NETWORK_SEARCH_TERMS:
      return setResponseTerms(state, action);
      break;

    // case COLLAB_CLUSTER_UPDATE:
    //   return updateCluster(state, action);

    default:
      return state;
      break;
  }
};
